var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "service-type-info-container" },
    [
      _c("mq-layout", { attrs: { mq: "desktop" } }, [
        _c(
          "div",
          {
            staticClass: "destination-description truncate",
            attrs: { "aria-label": "service type and locations" }
          },
          [
            _c(
              "a",
              {
                staticClass: "location-link bold",
                attrs: {
                  title: "show service type",
                  "aria-label":
                    _vm.serviceTypeName() +
                    ", at time " +
                    _vm.getOrderTime +
                    ". Enter to change service type.",
                  tabindex: "0"
                },
                on: {
                  click: _vm.setInitialModal,
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.setInitialModal($event)
                  }
                }
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.serviceTypeName()))]),
                _vm._v(" "),
                _vm.orderTime
                  ? _c("span", [_vm._v(_vm._s(_vm.getOrderTime))])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.serviceType === _vm.EServiceType.SERVICE_TYPE_DELIVERY &&
            _vm.address
              ? [
                  _vm._v("\n\t\t\t\tto\n\t\t\t\t"),
                  _c(
                    "a",
                    {
                      staticClass: "location-link bold",
                      attrs: { title: "change address", tabindex: "0" },
                      on: {
                        click: _vm.setInitialModal,
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.setInitialModal($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.address.formattedAddress.split(",")[0] ||
                              _vm.address.formattedAddress
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v("\n\t\t\tfrom\n\t\t\t"),
            _c("span", [
              _c(
                "a",
                {
                  staticClass: "location-link bold",
                  attrs: {
                    title: "show store locations",
                    "aria-label":
                      "viewing store " +
                      _vm.location.name +
                      ". Enter to open store locator.",
                    tabindex: "0"
                  },
                  on: {
                    click: function($event) {
                      return _vm.showModal("locations")
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.showModal("locations")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" + _vm._s(_vm.location.name) + "\n\t\t\t\t"
                  )
                ]
              )
            ])
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("mq-layout", { attrs: { mq: "mobile" } }, [
        _c("div", { staticClass: "destination-description" }, [
          _vm.orderTime
            ? _c("div", { staticClass: "service-type-time" }, [
                _c(
                  "a",
                  {
                    staticClass: "location-link bold",
                    attrs: { title: "show order times", tabindex: "0" },
                    on: {
                      click: function($event) {
                        return _vm.showModal("OrderDetails")
                      }
                    }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.serviceTypeName()))]),
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.getOrderTime) + "\n\t\t\t\t"
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "service-type-location" },
            [
              _vm.serviceType === _vm.EServiceType.SERVICE_TYPE_DELIVERY &&
              _vm.address
                ? [
                    _vm._v("\n\t\t\t\t\tto\n\t\t\t\t\t"),
                    _c(
                      "a",
                      {
                        staticClass: "location-link bold",
                        attrs: { title: "show store locations", tabindex: "0" },
                        on: {
                          click: function($event) {
                            return _vm.showModal("OrderDetails")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.address.formattedAddress.split(",")[0] ||
                                _vm.address.formattedAddress
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba7f7c6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba7f7c6a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/ServiceTypeInfo.vue
// module id = null
// module chunks = 